module.exports = __webpack_public_path__ + "img/erp-logos_0003_woocommerce.64ff08bc.jpg";